class CartDrawer extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-drawer');
    this.notificationSuccess = this.notification.querySelector('.cart-drawer__success');

    this.button = document.getElementById('cart-icon-bubble');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    
    this.init();
  }

  init() {
    this.querySelectorAll('button[type="button"].cart-drawer__close').forEach((closeButton) =>
    closeButton.addEventListener('click', this.close.bind(this))
    );
  }


  open() {
    this.notification.classList.add('animate', 'active');
    this.classList.add('active');
    this.button.classList.add('animate', 'active');
    document.body.classList.add('overflow-hidden');





    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);
  }

  close() {
    this.notification.classList.remove('active');
    this.classList.remove('active');
    this.button.classList.remove('active');
    if (this.notificationSuccess) this.notificationSuccess.classList.add('hidden');

    document.body.removeEventListener('click', this.onBodyClick);
    document.body.classList.remove('overflow-hidden');

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.productId = parsedState.id;
    this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));
      if (this.notificationSuccess) this.notificationSuccess.classList.remove('hidden');
      if (this.header) this.header.reveal();
    this.open();
    this.init();
  }


  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-products'
      },
      {
        id: 'cart-notification-links'
      },
      {
        id: 'cart-notification-warning'
      },
      {
        id: 'cart-notification-extra'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }


  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && target !== this.button && !target.closest('cart-drawer') && !target.closest('modal-dialog')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }
}

customElements.define('cart-drawer', CartDrawer);


class CartLink extends HTMLElement {
  constructor() {
    super();

    this.cartNotification = document.querySelector('cart-drawer');
    if (this.cartNotification) {
       
      this.addEventListener('click', (event) => {
        event.preventDefault();
        if (this.cartNotification.header) this.cartNotification.header.reveal();
        this.cartNotification.open();
      });
    }
  }

}

customElements.define('cart-link', CartLink);

if (!customElements.get('cart-drawer-items')) {


  class CartNotificationItems extends HTMLElement {
    constructor() {
      super();

      this.lineItemStatusElement = document.getElementById('cart-drawer-shopping-cart-line-item-status');

      this.currentItemCount = Array.from(this.querySelectorAll('[name="updates[]"]'))
        .reduce((total, quantityInput) => total + parseInt(quantityInput.value), 0);

      this.debouncedOnChange = debounce((event) => {
        this.onChange(event);
      }, 300);

      this.addEventListener('change', this.debouncedOnChange.bind(this));
    }

    // handleAddonSelectionChange moved to CartAddonForm custom element

    handleAddonSubmit(event) {
      const trigger = event.target.closest('[data-addon-submit]');
      if (!trigger) return;
      event.preventDefault();
      if (trigger.getAttribute('aria-disabled') === 'true') return;
      const form = trigger.closest('[data-cart-addon-form]');
      if (!form) return;
      const parentLineKey = form.getAttribute('data-parent-line-key');
      if (!parentLineKey) return;
      const checked = form.querySelectorAll('input[type="radio"]:checked');
      if (!checked.length) return;
      const cartDrawerItems = document.querySelector('cart-drawer-items');
      if (!cartDrawerItems) return;
      const sections = cartDrawerItems.getSectionsToRender().map((s) => s.section);
      const errorEl = form.querySelector('[data-addon-error]');
      if (errorEl) {
        errorEl.classList.add('hidden');
        errorEl.textContent = '';
      }
      trigger.setAttribute('aria-disabled', 'true');

      const childIndexesRaw = form.getAttribute('data-child-line-indexes') || '';
      const childIndexes = childIndexesRaw.split('|||').map((n) => parseInt(n.trim(), 10)).filter((n) => !isNaN(n) && n > 0);

      const doAdd = () => {
        const currentParentKey = form.getAttribute('data-parent-line-key');
        if (!currentParentKey) return Promise.reject(new Error('Missing parent line key'));
        const checkedInputs = form.querySelectorAll('input[type="radio"]:checked');
        const items = Array.from(checkedInputs).map((input) => ({
          id: parseInt(input.value, 10),
          quantity: 1,
          parent_line_key: currentParentKey
        }));
        const body = JSON.stringify({
          items,
          sections,
          sections_url: window.location.pathname
        });
        return fetch(`${routes.cart_add_url}`, { ...fetchConfig(), body })
          .then((response) => response.json())
          .then((data) => {
            if (data.status && data.status === 422) {
              if (errorEl) {
                errorEl.textContent = data.description || data.message || window.cartStrings?.error || 'Error';
                errorEl.classList.remove('hidden');
              }
              trigger.setAttribute('aria-disabled', 'false');
              return;
            }
            const parsedState = data;
            cartDrawerItems.classList.toggle('is-empty', parsedState.item_count === 0);
            const cartFooter = document.getElementById('main-cart-footer');
            if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
            cartDrawerItems.getSectionsToRender().forEach((section) => {
              const el = document.getElementById(section.id);
              if (!el) return;
              const selector = section.selector || '.shopify-section';
              const target = el.querySelector(selector) || el;
              const html = parsedState.sections && parsedState.sections[section.section];
              if (html) target.innerHTML = cartDrawerItems.getSectionInnerHTML(html, selector);
            });
            const modal = form.closest('modal-dialog');
            if (modal && typeof modal.hide === 'function') modal.hide();
            document.dispatchEvent(new CustomEvent('cart:updated'));
          })
          .catch(() => {
            if (errorEl) {
              errorEl.textContent = window.cartStrings?.error || 'Error';
              errorEl.classList.remove('hidden');
            }
            trigger.setAttribute('aria-disabled', 'false');
          });
      };

      if (childIndexes.length > 0) {
        const sections = cartDrawerItems.getSectionsToRender().map((s) => s.section);
        const removeOne = (lineIndex) =>
          fetch(`${routes.cart_change_url}`, {
            ...fetchConfig(),
            body: JSON.stringify({
              line: lineIndex,
              quantity: 0,
              sections,
              sections_url: window.location.pathname
            })
          }).then((r) => r.json());
        const sortedIndexes = [...childIndexes].sort((a, b) => b - a);
        sortedIndexes
          .reduce((promise, lineIndex) => promise.then(() => removeOne(lineIndex)), Promise.resolve())
          .then(() => doAdd())
          .catch(() => {
            if (errorEl) {
              errorEl.textContent = window.cartStrings?.error || 'Error';
              errorEl.classList.remove('hidden');
            }
            trigger.setAttribute('aria-disabled', 'false');
          });
      } else {
        doAdd();
      }
    }

    onChange(event) {
      this.updateQuantity(event.target.dataset.index, event.target.value, document.activeElement.getAttribute('name'), event.target);
    }

    getSectionsToRender() {
      return [
        {
          id: 'cart-notification-products',
          section: 'cart-notification-products',
          selector: '.shopify-section'
        },
        {
          id: 'cart-notification-links',
          section: 'cart-notification-links',
          selector: '.shopify-section'
        },
        {
          id: 'cart-notification-warning',
          section: 'cart-notification-warning',
          selector: '.shopify-section'
        },
        {
          id: 'cart-notification-extra',
          section: 'cart-notification-extra',
          selector: '.shopify-section'
        },
        {
          id: 'cart-icon-bubble',
          section: 'cart-icon-bubble',
          selector: '.shopify-section'
        }
      ];
    }

    addProduct(id, quantity) {
      const body = JSON.stringify({
        id,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname,
      });

      fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartFooter = document.getElementById('main-cart-footer');
          const cartItems = document.getElementById('main-cart-items');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
        
            elementToReplace.innerHTML =
              this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);

        
          }));
          cartItems.scrollIntoView();

          this.disableLoading();
        }).catch((e) => {
          this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
          document.getElementById('notification-cart-errors').textContent = window.cartStrings.error;
          this.disableLoading();
        });
    }



    updateQuantity(line, quantity, name, input) {
      this.max = input.max;      
      if (this.max) {
        if (quantity > input.max) {
          document.getElementById(`Line-item-error-${line}`)
            .querySelector('.notification-cart-item__error-text')
            .innerHTML = window.cartStrings.quantityError.replace(
              '[quantity]',
              input.max
            );
          quantity = input.max;
        }
      }
      
      this.enableLoading(line);


      const body = JSON.stringify({
        line,
        quantity,
        sections: this.getSectionsToRender().map((section) => section.section),
        sections_url: window.location.pathname
      });


      fetch(`${routes.cart_change_url}`, { ...fetchConfig(), ...{ body } })
        .then((response) => {
          return response.text();
        })
        .then((state) => {
          const parsedState = JSON.parse(state);
          this.classList.toggle('is-empty', parsedState.item_count === 0);
          const cartFooter = document.getElementById('main-cart-footer');

          if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);

          this.getSectionsToRender().forEach((section => {
            const elementToReplace =
              document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);

            elementToReplace.innerHTML =
              this.getSectionInnerHTML(parsedState.sections[section.section], section.selector);
          }));

          this.updateLiveRegions(line, parsedState.item_count);
          const lineItem = document.getElementById(`CartItem-${line}`);
          if (lineItem && lineItem.querySelector(`[name="${name}"]`)) lineItem.querySelector(`[name="${name}"]`).focus();
          this.disableLoading();
        }).catch((e) => {
          this.querySelectorAll('.loading-overlay').forEach((overlay) => overlay.classList.add('hidden'));
          document.getElementById('notification-cart-errors').textContent = window.cartStrings.error;
          this.disableLoading();
        });
    }

    updateLiveRegions(line, itemCount) {
      // console.log(line);
      // if (this.currentItemCount === itemCount) {
      //   document.getElementById(`Line-item-error-${line}`)
      //     .querySelector('.notification-cart-item__error-text')
      //     .innerHTML = window.cartStrings.quantityError.replace(
      //       '[quantity]',
      //       document.getElementById(`Quantity-${line}`).value
      //     );
      // }

      this.currentItemCount = itemCount;
      this.lineItemStatusElement.setAttribute('aria-hidden', true);

      const cartStatus = document.getElementById('cart-drawer-cart-live-region-text');
      cartStatus.setAttribute('aria-hidden', false);

      setTimeout(() => {
        cartStatus.setAttribute('aria-hidden', true);
      }, 1000);
    }

    getSectionInnerHTML(html, selector) {
      return new DOMParser()
        .parseFromString(html, 'text/html')
        .querySelector(selector).innerHTML;
    }

    enableLoading(line) {
      line = line + 1;
      document.getElementById('cart-drawer').classList.add('cart__items--disabled');
      this.querySelectorAll(`#cart-drawer-product-${line} .loading-overlay`).forEach((overlay) => overlay.classList.remove('hidden'));
      document.activeElement.blur();
      this.lineItemStatusElement.setAttribute('aria-hidden', false);
    }

    disableLoading() {
      document.getElementById('cart-drawer').classList.remove('cart__items--disabled');
    }
  }

  customElements.define('cart-drawer-items', CartNotificationItems);
}

class CartAddonForm extends HTMLElement {
  connectedCallback() {
    this.submitBtn = this.querySelector('[data-addon-submit]');
    this.priceEl = this.querySelector('[data-addon-total]');
    this.labelEl = this.querySelector('.cart-line-addons__submit-label');

    if (!this.submitBtn) return;

    const baseLabel =
      (this.labelEl && (this.labelEl.getAttribute('data-base-label') || this.labelEl.textContent.trim())) ||
      this.submitBtn.textContent.trim();

    if (this.labelEl && !this.labelEl.getAttribute('data-base-label')) {
      this.labelEl.setAttribute('data-base-label', baseLabel);
    }

    this.handleChange = this.handleChange.bind(this);
    this.addEventListener('change', this.handleChange);

    this.updateFromSelection();
  }

  handleChange(event) {
    if (!event.target.matches('input[type=\"radio\"]')) return;
    this.updateFromSelection();
  }

  updateFromSelection() {
    const checked = this.querySelectorAll('input[type=\"radio\"]:checked');
    const hasSelection = checked.length > 0;

    if (this.submitBtn) {
      this.submitBtn.setAttribute('aria-disabled', hasSelection ? 'false' : 'true');
      if (hasSelection) {
        this.submitBtn.removeAttribute('tabindex');
      } else {
        this.submitBtn.setAttribute('tabindex', '-1');
      }
    }

    if (!this.priceEl) return;

    let totalCents = 0;
    checked.forEach((input) => {
      const priceAttr = input.getAttribute('data-addon-price');
      const cents = priceAttr ? parseInt(priceAttr, 10) : 0;
      if (!Number.isNaN(cents)) totalCents += cents;
    });

    if (hasSelection && totalCents > 0 && window.Currency && typeof window.Currency.formatMoney === 'function') {
      const format = (window.currency && (window.currency.moneyFormat || window.currency.currencyFormat)) || window.moneyFormat;
      const formatted = window.Currency.formatMoney(totalCents, format);
      this.priceEl.textContent = `+ ${formatted}`;
    } else {
      this.priceEl.textContent = '';
    }
  }
}

if (!customElements.get('cart-addon-form')) {
  customElements.define('cart-addon-form', CartAddonForm);
}

document.addEventListener('change', (e) => {
  if (!e.target.closest('[data-cart-addon-form]')) return;
  // Handled by CartAddonForm custom element
});

document.addEventListener('click', (e) => {
  const addTrigger = e.target.closest('.cart-line-addons__trigger');
  if (!addTrigger) return;
  const opener = addTrigger.closest('modal-opener');
  if (!opener) return;
  const modalSelector = opener.getAttribute('data-modal');
  const modal = modalSelector ? document.querySelector(modalSelector) : null;
  if (!modal) return;
  const form = modal.querySelector('[data-cart-addon-form]');
  if (form) {
    form.querySelectorAll('input[type="radio"]').forEach((radio) => {
      radio.checked = false;
    });
    form.removeAttribute('data-child-line-indexes');
    const submitBtn = form.querySelector('[data-addon-submit]');
    if (submitBtn) {
      submitBtn.setAttribute('aria-disabled', 'true');
      submitBtn.setAttribute('tabindex', '-1');
    }
    const priceEl = form.querySelector('[data-addon-total]');
    if (priceEl) {
      priceEl.textContent = '';
    }
    const errorEl = form.querySelector('[data-addon-error]');
    if (errorEl) {
      errorEl.classList.add('hidden');
      errorEl.textContent = '';
    }
  }
}, true);

document.addEventListener('click', (e) => {
  const submit = e.target.closest('[data-addon-submit]');
  if (!submit) return;
  const items = document.querySelector('cart-drawer-items');
  if (items && items.handleAddonSubmit) items.handleAddonSubmit(e);
});

document.addEventListener('click', (e) => {
  const editBtn = e.target.closest('[data-addon-edit]');
  if (!editBtn) return;
  e.preventDefault();
  const variantIds = (editBtn.getAttribute('data-selected-variants') || '').split(',').map((id) => id.trim()).filter(Boolean);
  const parentLineKey = editBtn.getAttribute('data-parent-line-key');
  const modalSelector = editBtn.getAttribute('data-modal');
  const modal = modalSelector ? document.querySelector(modalSelector) : null;
  if (!modal) return;
  const form = modal.querySelector('[data-cart-addon-form]');
  if (form) {
    if (parentLineKey) form.setAttribute('data-parent-line-key', parentLineKey);
    const childLineIndexes = editBtn.getAttribute('data-child-line-indexes') || '';
    form.setAttribute('data-child-line-indexes', childLineIndexes);
    form.querySelectorAll('input[type="radio"]').forEach((radio) => {
      radio.checked = variantIds.includes(radio.value);
    });
    const submitBtn = form.querySelector('[data-addon-submit]');
    if (submitBtn) {
      submitBtn.setAttribute('aria-disabled', 'false');
      submitBtn.removeAttribute('tabindex');
    }

    // Recalculate and show current add-on total on the button
    const firstChecked = form.querySelector('input[type="radio"]:checked');
    if (firstChecked) {
      firstChecked.dispatchEvent(new Event('change', { bubbles: true }));
    }
  }
  if (typeof modal.show === 'function') modal.show(editBtn);
});

document.addEventListener('click', (e) => {
  const removeBtn = e.target.closest('[data-addon-remove]');
  if (!removeBtn) return;
  e.preventDefault();
  const indexesRaw = removeBtn.getAttribute('data-child-line-indexes') || '';
  const childIndexes = indexesRaw.split('|||').map((n) => parseInt(n.trim(), 10)).filter((n) => !isNaN(n) && n > 0);
  if (childIndexes.length === 0) return;
  const cartDrawerItems = document.querySelector('cart-drawer-items');
  if (!cartDrawerItems) return;
  const sections = cartDrawerItems.getSectionsToRender().map((s) => s.section);
  const removeOne = (lineIndex) =>
    fetch(`${routes.cart_change_url}`, {
      ...fetchConfig(),
      body: JSON.stringify({
        line: lineIndex,
        quantity: 0,
        sections,
        sections_url: window.location.pathname
      })
    }).then((r) => r.json());
  const sortedIndexes = [...childIndexes].sort((a, b) => b - a);
  sortedIndexes
    .reduce((promise, lineIndex) => promise.then(() => removeOne(lineIndex)), Promise.resolve())
    .then((parsedState) => {
      if (parsedState.status && parsedState.status === 422) return;
      cartDrawerItems.classList.toggle('is-empty', parsedState.item_count === 0);
      const cartFooter = document.getElementById('main-cart-footer');
      if (cartFooter) cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
      cartDrawerItems.getSectionsToRender().forEach((section) => {
        const el = document.getElementById(section.id);
        if (!el) return;
        const selector = section.selector || '.shopify-section';
        const target = el.querySelector(selector) || el;
        const html = parsedState.sections && parsedState.sections[section.section];
        if (html) target.innerHTML = cartDrawerItems.getSectionInnerHTML(html, selector);
      });
      document.dispatchEvent(new CustomEvent('cart:updated'));
    })
    .catch(() => {
      const errorEl = document.getElementById('notification-cart-errors');
      if (errorEl) errorEl.textContent = window.cartStrings?.error || 'Error';
    });
});

class NotificationCartRemoveButton extends HTMLElement {
  constructor() {
    super();
    this.addEventListener('click', (event) => {
      event.preventDefault();
      this.closest('cart-drawer-items').updateQuantity(this.dataset.index, 0, document.activeElement.getAttribute('name'), event.target);
    });
  }
}

customElements.define('notification-cart-remove-button', NotificationCartRemoveButton);

class CartGiftOffers extends HTMLElement {
  constructor() {
    super();
    this.giftOffers = [];
    this.processedGifts = new Set();
    this.isProcessing = false;

    // Global guard to prevent duplicate gift additions across multiple instances
    if (!window.__cartGiftProcessedVariants) {
      window.__cartGiftProcessedVariants = {};
    }

    this.init();
  }

  init() {
    const giftOffersData = this.dataset.giftOffers;
    if (giftOffersData) {
      try {
        this.giftOffers = JSON.parse(giftOffersData);
      } catch (e) {
        console.error('Failed to parse gift offers:', e);
        return;
      }
    }

    this.observeCartChanges();
    setTimeout(() => this.checkAndAddGifts(), 100);
  }

  observeCartChanges() {
    const observer = new MutationObserver((mutations) => {
      for (const mutation of mutations) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-gift-offers') {
          const giftOffersData = this.dataset.giftOffers;
          if (giftOffersData) {
            try {
              this.giftOffers = JSON.parse(giftOffersData);
            } catch (e) {
              console.error('Failed to parse gift offers:', e);
            }
          }
        }
      }

      this.checkAndAddGifts();
    });

    const warningElement = document.getElementById('cart-notification-warning');
    if (warningElement) {
      observer.observe(warningElement, {
        childList: true,
        subtree: true,
      });
    }

    observer.observe(this, {
      attributes: true,
      attributeFilter: ['data-gift-offers', 'data-cart-total'],
    });

    document.addEventListener('cart:updated', () => {
      setTimeout(() => this.checkAndAddGifts(), 100);
    });
  }

  async checkAndAddGifts() {
    if (this.giftOffers.length === 0 || this.isProcessing) return;

    this.isProcessing = true;

    try {
      let cartData = await this.getCartData();
      if (!cartData) return;

      const cartTotal = cartData.total_price || 0;

      // Collect unique variant ids that should be present as gifts
      const variantsToEnsure = new Set();

      for (const offer of this.giftOffers) {
        const threshold = parseInt(offer.threshold);
        const variantGid = offer.variantGid;

        if (!variantGid || !threshold) continue;
        if (cartTotal < threshold) continue;

        const variantId = this.extractVariantId(variantGid);
        if (!variantId) continue;

        variantsToEnsure.add(variantId);
      }

      // Ensure each qualifying variant is present at most once as a gift
      for (const variantId of variantsToEnsure) {
        const giftKey = `${variantId}-gift`;

        // If we've already processed this variant once in this instance, never add it again
        if (this.processedGifts.has(giftKey)) {
          continue;
        }

        // If we've already processed this variant globally (across instances), skip
        if (window.__cartGiftProcessedVariants[giftKey]) {
          continue;
        }

        const isGiftInCart = this.isGiftInCart(cartData, variantId);

        if (!isGiftInCart) {
          // Mark as processed globally immediately to guard against races
          window.__cartGiftProcessedVariants[giftKey] = true;
          await this.addGiftToCart(variantId);
        }

        // Mark this variant as processed so we never auto-add it again
        this.processedGifts.add(giftKey);
      }
    } finally {
      this.isProcessing = false;
    }
  }

  extractVariantId(gid) {
    const match = gid.match(/\/ProductVariant\/(\d+)/);
    return match ? match[1] : null;
  }

  isGiftInCart(cartData, variantId) {
    if (!cartData || !cartData.items || !cartData.items.length) return false;

    const numericVariantId = parseInt(variantId);

    return cartData.items.some((item) => {
      if (!item || item.variant_id !== numericVariantId) return false;

      const props = item.properties || {};
      // Support different casings / representations, but we only care about a truthy "gift" flag
      const giftValue =
        props.gift ??
        props.Gift ??
        (props['gift'] !== undefined ? props['gift'] : props['Gift']);

      if (giftValue === undefined || giftValue === null) return false;

      const giftStr = String(giftValue).toLowerCase();
      return giftStr === 'true' || giftStr === '1' || giftStr === 'yes';
    });
  }

  async getCartData() {
    try {
      const response = await fetch('/cart.js');
      if (!response.ok) return null;
      return await response.json();
    } catch (e) {
      console.error('Failed to fetch cart data:', e);
      return null;
    }
  }

  async addGiftToCart(variantId) {
    const cartDrawerItems = document.querySelector('cart-drawer-items');
    if (!cartDrawerItems) return;

    const body = JSON.stringify({
      items: [
        {
          id: variantId,
          quantity: 1,
          properties: {
            gift: 'true',
          },
        },
      ],
      sections: cartDrawerItems.getSectionsToRender().map((section) => section.section),
      sections_url: window.location.pathname,
    });

    try {
      const response = await fetch(`${routes.cart_add_url}`, {
        ...fetchConfig(),
        body,
      });

      if (!response.ok) {
        console.error('[CartGiftOffers] addGiftToCart:response error', {
          status: response.status,
          statusText: response.statusText
        });
        throw new Error('Failed to add gift to cart');
      }

      const state = await response.text();
      const parsedState = JSON.parse(state);

      cartDrawerItems.classList.toggle('is-empty', parsedState.item_count === 0);

      const cartFooter = document.getElementById('main-cart-footer');
      if (cartFooter) {
        cartFooter.classList.toggle('is-empty', parsedState.item_count === 0);
      }

      cartDrawerItems.getSectionsToRender().forEach((section) => {
        const elementToReplace =
          document.getElementById(section.id).querySelector(section.selector) ||
          document.getElementById(section.id);

        elementToReplace.innerHTML = cartDrawerItems.getSectionInnerHTML(
          parsedState.sections[section.section],
          section.selector
        );
      });

      document.dispatchEvent(new CustomEvent('cart:updated'));
    } catch (e) {
      console.error('Failed to add gift to cart:', e);
    }
  }
}

customElements.define('cart-gift-offers', CartGiftOffers);
